import React from 'react';

type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'ghost';

interface ActionButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  loading?: boolean;
}

const variants: Record<ButtonVariant, string> = {
  primary: 'bg-accent hover:bg-accent-hover text-white shadow-sm shadow-accent/20',
  secondary:
    'bg-dark-surface border border-dark-border text-gray-200 hover:bg-dark-border',
  danger: 'bg-red-600 hover:bg-red-700 text-white',
  ghost: 'text-link hover:text-sky-300 bg-transparent',
};

export function ActionButton({
  variant = 'primary',
  loading,
  children,
  className = '',
  disabled,
  ...props
}: ActionButtonProps) {
  return (
    <button
      className={`inline-flex items-center justify-center gap-2 rounded-xl px-4 py-2.5 text-sm font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-50 ${variants[variant]} ${className}`}
      disabled={disabled || loading}
      {...props}
    >
      {loading && (
        <span className="h-4 w-4 animate-spin rounded-full border-2 border-white/30 border-t-white" />
      )}
      {children}
    </button>
  );
}
